import {
  BasicButton,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
} from "@certn/cascadia-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type GroupActiveToggleModalProps = {
  onClose: () => void;
  destination: string;
};

export function UnsavedChangesModal(props: GroupActiveToggleModalProps) {
  const { destination, onClose } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal isOpen>
      <Dialog>
        <DialogHeader onClose={onClose}>{t("Unsaved changes")}</DialogHeader>
        <DialogContent>
          {t(
            "Are you sure you want to discard changes? Any edits you made won't be saved."
          )}
        </DialogContent>
        <DialogFooter>
          <ButtonGroup>
            <BasicButton size="medium" onPress={onClose}>
              {t("Cancel")}
            </BasicButton>
            <PrimaryButton
              size="medium"
              onPress={() => navigate(destination)} // on press we need to either nav back to list or overview
              testID="leave-group-create"
            >
              {t("Discard changes")}
            </PrimaryButton>
          </ButtonGroup>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
